(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'jquery', 'jquery-kotlin-jsLegacy', 'kvision-js-legacy', 'kotlinx-serialization-kotlinx-serialization-core-js-legacy', 'kotlinx-serialization-kotlinx-serialization-json-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('jquery'), require('jquery-kotlin-jsLegacy'), require('kvision-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-core-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-json-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-jquery-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-jquery-js-legacy'.");
    }if (typeof jQuery === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-jquery-js-legacy'. Its dependency 'jquery' was not found. Please, check whether 'jquery' is loaded prior to 'kvision-kvision-jquery-js-legacy'.");
    }if (typeof this['jquery-kotlin-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-jquery-js-legacy'. Its dependency 'jquery-kotlin-jsLegacy' was not found. Please, check whether 'jquery-kotlin-jsLegacy' is loaded prior to 'kvision-kvision-jquery-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-jquery-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-jquery-js-legacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-jquery-js-legacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' is loaded prior to 'kvision-kvision-jquery-js-legacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-json-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-jquery-js-legacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json-js-legacy' is loaded prior to 'kvision-kvision-jquery-js-legacy'.");
    }root['kvision-kvision-jquery-js-legacy'] = factory(typeof this['kvision-kvision-jquery-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-jquery-js-legacy'], kotlin, jQuery, this['jquery-kotlin-jsLegacy'], this['kvision-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-json-js-legacy']);
  }
}(this, function (_, Kotlin, $module$jquery, $module$jquery_kotlin_jsLegacy, $module$kvision_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Enum = Kotlin.kotlin.Enum;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var throwISE = Kotlin.throwISE;
  var Display = $module$kvision_js_legacy.io.kvision.core.Display;
  var Widget = $module$kvision_js_legacy.io.kvision.core.Widget;
  var iterator = Kotlin.kotlin.js.iterator_s8jyvk$;
  var defineInlineFunction = Kotlin.defineInlineFunction;
  var wrapFunction = Kotlin.wrapFunction;
  var toString = Kotlin.toString;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var Exception_init = Kotlin.kotlin.Exception_init_pdl1vj$;
  var Exception = Kotlin.kotlin.Exception;
  var equals = Kotlin.equals;
  var Unit = Kotlin.kotlin.Unit;
  var utils = $module$kvision_js_legacy.io.kvision.utils;
  var Json = $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy.kotlinx.serialization.json.Json_x26noe$;
  var getKClass = Kotlin.getKClass;
  var types = $module$kvision_js_legacy.io.kvision.types;
  var overwriteWith = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.modules.overwriteWith_nz2fmb$;
  var Object_init = Object;
  var SerializersModuleBuilder_init = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.modules.SerializersModuleBuilder;
  function getElementJQuery($receiver) {
    var tmp$;
    return (tmp$ = $receiver.getElement()) != null ? $module$jquery(tmp$) : null;
  }
  function getElementJQueryD($receiver) {
    var tmp$;
    return (tmp$ = $receiver.getElement()) != null ? $module$jquery(tmp$) : null;
  }
  var Easing$SWING_instance;
  var Easing$LINEAR_instance;
  function bindAllJQueryListeners(widget, jqueryListenersMap) {
    var tmp$;
    if ((tmp$ = getElementJQuery(widget)) != null) {
      if (jqueryListenersMap != null) {
        var tmp$_0;
        tmp$_0 = jqueryListenersMap.entries.iterator();
        while (tmp$_0.hasNext()) {
          var element = tmp$_0.next();
          var event = element.key;
          var handlers = element.value;
          var tmp$_1;
          tmp$_1 = handlers.entries.iterator();
          while (tmp$_1.hasNext()) {
            var element_0 = tmp$_1.next();
            var handler = element_0.value;
            tmp$.on(event, handler);
          }
        }
      }}}
  function removeAllJQueryListeners(widget, jqueryListenersMap) {
    var tmp$;
    if ((tmp$ = getElementJQuery(widget)) != null) {
      if (jqueryListenersMap != null) {
        var tmp$_0;
        tmp$_0 = jqueryListenersMap.entries.iterator();
        while (tmp$_0.hasNext()) {
          var element = tmp$_0.next();
          var event = element.key;
          var handlers = element.value;
          var tmp$_1;
          tmp$_1 = handlers.entries.iterator();
          while (tmp$_1.hasNext()) {
            var element_0 = tmp$_1.next();
            var handler = element_0.value;
            tmp$.off(event, handler);
          }
        }
      }}}
  var HttpMethod$GET_instance;
  var HttpMethod$POST_instance;
  var HttpMethod$PUT_instance;
  var HttpMethod$DELETE_instance;
  var HttpMethod$OPTIONS_instance;
  var HttpMethod$HEAD_instance;
  var XHR_ERROR;
  var HTTP_BAD_REQUEST;
  var HTTP_UNAUTHORIZED;
  var HTTP_FORBIDDEN;
  var HTTP_NOT_FOUND;
  var HTTP_NOT_ALLOWED;
  var HTTP_SERVER_ERROR;
  var HTTP_NOT_IMPLEMENTED;
  var HTTP_BAD_GATEWAY;
  var HTTP_SERVICE_UNAVAILABLE;
  var RemoteRequestException$Companion_instance = null;
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  var package$core = package$kvision.core || (package$kvision.core = {});
  package$core.getElementJQuery_tqt9mm$ = getElementJQuery;
  package$core.getElementJQueryD_tqt9mm$ = getElementJQueryD;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  package$core.bindAllJQueryListeners_yw480n$ = bindAllJQueryListeners;
  package$core.removeAllJQueryListeners_yw480n$ = removeAllJQueryListeners;
  $$importsForInline$$['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy;
  XHR_ERROR = 0;
  HTTP_BAD_REQUEST = 400;
  HTTP_UNAUTHORIZED = 401;
  HTTP_FORBIDDEN = 403;
  HTTP_NOT_FOUND = 404;
  HTTP_NOT_ALLOWED = 405;
  HTTP_SERVER_ERROR = 500;
  HTTP_NOT_IMPLEMENTED = 501;
  HTTP_BAD_GATEWAY = 502;
  HTTP_SERVICE_UNAVAILABLE = 503;
  return _;
}));

//# sourceMappingURL=kvision-kvision-jquery-js-legacy.js.map
